import { signify } from "react-signify";

export const sEmail = signify("");
export const sEmailError = signify("");
